export default __webpack_public_path__ + "static/media/imageuno.5223b984.jpg";